import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bf-modal bf-modal--region-courses" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "bf-heading-display text-body mb-3" }
const _hoisted_4 = { class: "flex-shrink-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "d-flex align-items-center mb-3" }
const _hoisted_8 = { class: "flex-shrink-0 me-4" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "opacity-60" }, "Gebietsleitung", -1)
const _hoisted_11 = { class: "h3 mb-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "staatl. geprüfte Physiotherapeutin", -1)
const _hoisted_13 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-phone" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 1,
  class: "my-5 text-center"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegionCourses = _resolveComponent("RegionCourses")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.shown,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shown) = $event)),
    close: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.loading && _ctx.regionLocal)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, "Kursliste " + _toDisplayString(_ctx.regionLocal.name), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "modal-close-button",
                    "aria-label": "Schließen",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
                  }, _hoisted_6)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: _ctx.regionLocal.manager.avatar_url || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN89h8AAtEB5wrzxXEAAAAASUVORK5CYII=',
                    class: "bf-profile-picture bf-profile-picture--shaped",
                    width: "300",
                    height: "300",
                    alt: 'Gebietsleitung ' + _ctx.regionLocal.name
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.regionLocal.manager.prename) + " " + _toDisplayString(_ctx.regionLocal.manager.surname), 1),
                  _hoisted_12,
                  (_ctx.regionLocal.manager.phone_mobile || _ctx.regionLocal.manager.email)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_ctx.regionLocal.manager.phone_mobile)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                              _hoisted_15,
                              _hoisted_16,
                              _createElementVNode("a", {
                                href: 'tel:'+_ctx.regionLocal.manager.phone_mobile
                              }, _toDisplayString(_ctx.regionLocal.manager.phone_mobile), 9, _hoisted_17)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.regionLocal.manager.email)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["fa fa-envelope", {'ms-3': _ctx.regionLocal.manager.phone_mobile}])
                              }, null, 2),
                              _hoisted_19,
                              _createElementVNode("a", {
                                href: 'mailto:'+_ctx.regionLocal.manager.email
                              }, _toDisplayString(_ctx.regionLocal.manager.email), 9, _hoisted_20)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    class: "btn btn-sm btn-primary mt-3",
                    href: _ctx.$navigation.buildRouteUrl('region', {slug: _ctx.regionLocal.slug})
                  }, "Gebietsseite öffnen", 8, _hoisted_21)
                ])
              ])
            ], 64))
          : (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
            : _createCommentVNode("", true),
        (_ctx.regionId || _ctx.regionLocal)
          ? (_openBlock(), _createBlock(_component_RegionCourses, {
              key: 2,
              regionId: _ctx.regionId || _ctx.regionLocal.id
            }, null, 8, ["regionId"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "close"]))
}